let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8hbZ5")).then(() => parcelRequire('j00wp'));